import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import css from './ReferralCodePage.module.css';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { Footer, LayoutSingleColumn, Modal, Page, H1, H3, NamedLink } from '../../components';
import { contactUsMessage, getStrapiReferContent } from '../../util/api';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withViewport } from '../../util/uiHelpers';
import { types as sdkTypes } from '../../util/sdkLoader';
import ReferralCodeForm from '../ReferralCodePage/ReferralCodeForm';

const { Money } = sdkTypes;
const ReferralCodePageComponent = props => {
  const { intl, scrollingDisabled, currentUser, userShowError, onCreateListingDraft } = props;

  const [isSendMail, setIsSendMail] = useState(false);
  const [referralContent, setReferralContent] = useState(false);
  const title = intl.formatMessage({ id: 'ContactUsPage.title' });
  const { publicData, firstName, lastName } = currentUser?.attributes?.profile || {};
  const referralCode = publicData?.referralCode;
  const fullName = firstName + ' ' + lastName;

  useEffect(() => {
    fetchReferralContent();
  }, []);

  const fetchReferralContent = async () => {
    try {
      const res = await getStrapiReferContent({});
      setReferralContent(res?.data?.attributes?.ImageAndVideo?.data ?? []);
    } catch (err) {
      console.log(err, '&&& &&& => err');
    }
  };

  const vendorId = currentUser?.id?.uuid;
  const handleSubmit = values => {
    const { email } = values;

    contactUsMessage({
      fullName: fullName,
      vendorId: vendorId,
      referralCode: referralCode,
      senderId: 'info@myfindor.com',
      customerId: email,
      subject: 'MyFindor Referral',
      text: 'text',
      referEmail: 'referral code',
    }).then(
      res => {
        setIsSendMail(true);
        setTimeout(() => {
          setIsSendMail(false);
        }, 3000);
      },
      error => {
        console.error(error);
        if (error) {
          console.error(error);
        }
      }
    );
  };

  return (
    <Page className={css.root} title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer currentPage="UserSendInvitation" />
          </>
        }
        footer={<FooterContainer />}
      >
        <div>
          <div className={css.contactWrapper}>
            {isSendMail ? (
              <div className={css.successMessage}>Referral sent successfully</div>
            ) : null}
            <ReferralCodeForm
              className={css.form}
              onSubmit={handleSubmit}
              isSendMail={isSendMail}
              referralContent={referralContent}
            />
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

ReferralCodePageComponent.defaultProps = {
  rootClassName: null,
  className: null,
};

ReferralCodePageComponent.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onCreateListingDraft: (values, config) => dispatch(requestCreateListingDraft(values, config)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});
const ReferralCodePage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withViewport,
  injectIntl
)(ReferralCodePageComponent);

export default injectIntl(ReferralCodePage);
